import { SystemGroupsPage } from "./SystemGroupsPage";
export default SystemGroupsPage;
